import { createContext } from 'react';
import { ErrorTypes } from './errorTypes';

const errorContext = createContext({} as ErrorTypes);
errorContext.displayName = 'ErrorContext';

export default errorContext;
